import MaterialSupplier from './MaterialSupplier'
import Model from './Model'
import { toFormData } from '@utils'

export default class Material extends Model
{
    filled () {
        if (this.suppliers?.data) {
            this.suppliers.data = MaterialSupplier.make(this.suppliers.data)
        }
    }

    getFormAttributes () {
        const attributes = this.only([
            'name', 'unit_of_measure', 'shape', 'weight', 'description', 'purchasable', 'sellable',
            'sale_description', 'quantity_of_sale', 'sale_cost', 'stock_control', 'sku', 'stock',
        ])

        attributes.manufacturer_id = this.manufacturer_dropdown
        attributes.categories = this.category_dropdown

        return attributes
    }

    static parseAttributes (attributes) {
        return this.parseDropdownAttributes(attributes, ['manufacturer_id', 'categories']);
    }

    static async all (compact = false) {
        const config = compact ? { params: { compact: true } } : {}
        const { data } = await Http.get(route('api.v1.materials.index'), config)
        return this.make(data)
    }

    static async price(materialId, estimateId = null) {
        const config = {params: {material_id: materialId}}

        if (_.isNumber(estimateId)) {
            config.params.estimate_id = estimateId
        }

        const {data} = await Http.get(route('api.v1.materials.price'), config)
        return data.price
    }

    static async search(query, compact = false, estimateId = null, limit = null) {
        const params = {query}
        if (compact) params.compact = true
        if (estimateId) params.estimate_id = estimateId
        if (limit) params.limit = limit
        const {data} = await Http.get(route('api.v1.materials.index'), {params})
        return this.make(data)
    }

    static async find (id) {
        const { data } = await Http.get(route('api.v1.materials.show', id))
        return this.make(data)
    }

    static async create (attributes) {
        const url = route('api.v1.materials.store')
        const payload = this.parseAttributes(attributes)
        const { data } = await Http.post(url, toFormData(payload))
        return this.make(data)
    }

    async update (attributes = {}) {
        const url = route('api.v1.materials.update', this.id)
        const payload = this.constructor.parseAttributes({ ...this.getFormAttributes(), ...attributes })
        const { data } = await Http.put(url, toFormData(payload))
        return this.fill(data)
    }

    async delete () {
        await Http.delete(route('api.v1.materials.destroy', this.id))
    }

    async searchCompanies (query, estimate_id = null) {
        const params = { query, estimate_id: estimate_id, material_id: this.id }
        const { data } = await Http.get(route('api.v1.materials.companies'), { params })
        return data
    }
}
